"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupPluginListeners = exports.buildPluginsReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const guardReducer = (pluginId, key, reducer) => (state, action) => {
    try {
        return reducer(state, action);
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[plugin-reducer] "${key}" (plugin ${pluginId}) threw on "${action.type}"; keeping prior slice state`, error);
        return state !== null && state !== void 0 ? state : null;
    }
};
// Each plugin's slice-tree mounts under its id, so slice-key collisions are structurally impossible.
const buildPluginsReducer = (registry) => {
    var _a;
    const tree = {};
    for (const plugin of registry.list()) {
        const own = (_a = plugin.reducers) !== null && _a !== void 0 ? _a : {};
        if (Object.keys(own).length === 0) {
            continue;
        }
        tree[plugin.id] = (0, toolkit_1.combineReducers)(Object.fromEntries(Object.entries(own).map(([key, reducer]) => [
            key,
            guardReducer(plugin.id, key, reducer),
        ])));
    }
    return Object.keys(tree).length > 0
        ? (0, toolkit_1.combineReducers)(tree)
        : (state = {}) => state;
};
exports.buildPluginsReducer = buildPluginsReducer;
const setupPluginListeners = (registry, startListening) => {
    var _a;
    const opaque = startListening;
    for (const plugin of registry.list()) {
        for (const setup of (_a = plugin.listeners) !== null && _a !== void 0 ? _a : []) {
            setup(opaque);
        }
    }
};
exports.setupPluginListeners = setupPluginListeners;
